import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from '../../../../model/project/project';
import Windowsticker, {
  TemporaryMaterialChoices,
} from '../../../../model/product/windowsticker/windowsticker';
import CustomWindowsticker from '../../../../model/product/windowsticker/custom-windowsticker';
import StickerPart from '../../../../model/product/windowsticker/sticker-part';
import { Subject } from 'rxjs';
import PMSColor from 'src/app/model/company/pmscolor';
import Company from 'src/app/model/company/company';

@Component({
  selector: 'custom-window-sticker',
  templateUrl: './custom-window-sticker.component.html',
  styleUrls: ['./custom-window-sticker.component.scss'],
})
export class CustomWindowStickerComponent implements OnInit {
  equalDisabled = false;
  temporaryMaterialOptions: any[];

  @Input()
  public inputProject: Project;

  @Input()
  public inputProduct: CustomWindowsticker;

  @Input()
  public involvedCompanies: Company[];

  @Input()
  public pmsColorAdded: Subject<PMSColor>;

  @Input()
  public client = false;

  @Input()
  public fromOldSystem = false;

  @Input()
  public disabled = false;

  @Output()
  public outPutWindowSticker = new EventEmitter<Windowsticker>();

  public inputWindowSticker;
  temporaryMaterialChanged = new EventEmitter<any>();

  constructor() {
    this.temporaryMaterialOptions = [
      TemporaryMaterialChoices.TEMPORARY,
      TemporaryMaterialChoices.PERMANENT,
    ];
  }

  ngOnInit() {
    if (this.inputProduct.stickerParts == null) {
      this.inputProduct.stickerParts = [];
      this.inputProduct.stickerParts.push(new StickerPart());
    } else if (this.inputProduct.stickerParts.length < 1) {
      this.inputProduct.stickerParts = [];
      this.inputProduct.stickerParts.push(new StickerPart());
    }
    this.inputProduct.standardStickerParts = [];
  }

  addStickerPart() {
    this.inputProduct.stickerParts.push(new StickerPart());
  }

  materialTypeUpdate(event) {
    delete this.inputProduct.foil;
    delete this.inputProduct.laminate;
    this.temporaryMaterialChanged.emit();
    this.outPutWindowSticker.emit();
  }

  Change() {
    this.outPutWindowSticker.emit();
  }

  windowHeightChange(event, index) {
    this.inputProduct.stickerParts[index].windowHeight = event;
    this.outPutWindowSticker.emit();
  }

  windowWidthChange(event, index) {
    this.inputProduct.stickerParts[index].windowWidth = event;
    this.outPutWindowSticker.emit();
  }

  stickerHeightChange(event, index) {
    this.inputProduct.stickerParts[index].stickerHeight = event;
    this.outPutWindowSticker.emit();
  }

  stickerWidthChange(event, index) {
    this.inputProduct.stickerParts[index].stickerWidth = event;
    this.outPutWindowSticker.emit();
  }

  descriptionChanged(event, index) {
    this.inputProduct.stickerParts[index].description = event;
    this.outPutWindowSticker.emit();
  }

  EqualSizes(index) {
    this.inputProduct.stickerParts[index].stickerHeight =
      this.inputProduct.stickerParts[index].windowHeight;
    this.inputProduct.stickerParts[index].stickerWidth =
      this.inputProduct.stickerParts[index].windowWidth;
    this.outPutWindowSticker.emit();
  }

  delete(index) {
    this.inputProduct.stickerParts.splice(index, 1);
    this.outPutWindowSticker.emit();
  }

  setWindowFrame(event) {
    this.inputProduct.windowFrame = event;
    this.outPutWindowSticker.emit();
  }

  setStickOver(event) {
    this.inputProduct.stickOverWindowFrame = event;
    this.outPutWindowSticker.emit();
  }
}
